import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { theme } from './utils/theme';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { BusinessFocus } from './pages/BusinessFocus';
import { Approach } from './pages/Approach';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfUse } from './pages/TermsOfUse';
import { NotFound } from './pages/NotFound';
export function App() {
  return <ChakraProvider theme={theme} data-id="element-0" data-mp="2mjzmv58kvpmk">
      <BrowserRouter data-id="element-1" data-mp="31ayqe1uk3nza">
        <Routes data-id="element-2" data-mp="31bi7xhgaoacs">
          <Route element={<Layout data-id="element-4" data-mp="31cjo20c63n1d" />} data-id="element-3" data-mp="31c1iue7j1yhb">
            <Route path="/" element={<Home data-id="element-6" data-mp="2wiyxgtcwlvc7" />} data-id="element-5" data-mp="2wk9y4kb1ymz3" />
            <Route path="/about" element={<About data-id="element-8" data-mp="2wi5qbra193tj" />} data-id="element-7" data-mp="2wifbn1k4umsw" />
            <Route path="/business-focus" element={<BusinessFocus data-id="element-10" data-mp="28sutgkvsztko" />} data-id="element-9" data-mp="28tw4wqgqei2x" />
            <Route path="/approach" element={<Approach data-id="element-12" data-mp="23w4fq47h1a2f" />} data-id="element-11" data-mp="28s2z1ddy01vz" />
            <Route path="/contact" element={<Contact data-id="element-14" data-mp="23ti8k5ohswkq" />} data-id="element-13" data-mp="23ujha3i1d6za" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-16" data-mp="3ij61y35c994p" />} data-id="element-15" data-mp="3ik7jmqgv0tve" />
            <Route path="/terms-of-use" element={<TermsOfUse data-id="element-18" data-mp="3ml17jjuay8oa" />} data-id="element-17" data-mp="3ii4sg33z0up3" />
            <Route path="*" element={<NotFound data-id="element-20" data-mp="3mjg7xft4rzjk" />} data-id="element-19" data-mp="3mjzsz5e2v41t" />
          </Route>
        </Routes>
      </BrowserRouter>
    </ChakraProvider>;
}